import { connect } from "react-redux";
import { first } from "lodash-es";

import { fetchEmails, TOGGLE_DETAILS } from "common/actions/email";

import { SummaryBar } from "../common/summaryBar";
import { dataSelectors } from "./helpers";

const summaries = [
    {
        ...dataSelectors.sent_count,
        size: 4
    }, {
        ...dataSelectors.delivered_count,
        size: 2
    }, {
        ...dataSelectors.bounce_count,
        size: 2
    }, {
        ...dataSelectors.open_count,
        size: 2
    }, {
        ...dataSelectors.click_count,
        size: 2
    }
];

const mapStateToProps = (state) => ({
    queryDeps: {
        date_range: state.common.date_range,
        qualifiers: state.emails.qualifiers
    },
    section: state.emails.section
});

const mapDispatchToProps = {
    TOGGLE_DETAILS
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(SummaryBar);

export function SummaryBarRedux(props) {
    return (
        <Connected
            summaries={summaries}
            queryKey="emails"
            queryFn={(...args) => fetchEmails(...args).then((results) => (results && results.length ? first(results) : {}))}
            {...props}
        />
    );
}
